
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  get_headers,
  USER_VERIFIED_DATA,

}  from '@/utils/constants/constants.js';
import axios from 'axios';


export default{
  name:'IdentityVerificationResults',
  mixins: [alert_mixin],
  props: {
    application_id: {
        type: [String, Number],
        required: true
    }
  },
  data:() => ({
  headers: get_headers(),
    formData: {
      full_name: '',
      surname: '',
      identity_number: '',
    },
    verification: {
      full_name: '',
      identity_number: '',
      date_of_birth: '',
      gender: '',
    },
    identity_match: '',
    raw_data: '',
    id_no_verified: false,

  }),

  computed: {
    identity_rows() {
      const provided_full =
        `${this.formData.full_name || ''} ${this.formData.surname || ''}` // keep existing state names as-is
          .replace(/\s+/g, ' ')
          .trim();

      const verified_full = (this.verification.full_name || '')
        .replace(/\s+/g, ' ')
        .trim();

      const both_full = provided_full && verified_full;
      const name_match = both_full
        ? this.normalize_text(provided_full) === this.normalize_text(verified_full)
        : null;

      const id_provided = this.formData.identity_number || '';
      const id_verified = this.verification.identity_number || '';
      const both_id = id_provided && id_verified;
      const id_match = both_id
        ? this.normalize_id(id_provided) === this.normalize_id(id_verified)
        : null;

      return [
        {
          key_label: 'Full name',
          value: provided_full || verified_full || '—',
          verified_value: both_full && !name_match ? verified_full : null,
          badge: name_match === null
            ? null
            : {
                text: name_match ? 'Match' : 'Mismatch',
                class_name: name_match ? 'bg-success' : 'bg-danger',
              },
        },
        {
          key_label: 'ID/ Passport No',
          value: id_provided || id_verified || '—',
          verified_value: both_id && !id_match ? id_verified : null,
          badge: id_match === null
            ? null
            : {
                text: id_match ? 'Match' : 'Mismatch',
                class_name: id_match ? 'bg-success' : 'bg-danger',
              },
        },
        {
          key_label: 'Date of Birth',
          value: this.verification.date_of_birth || '—',
        },
        {
          key_label: 'Verification status',
          value: this.id_no_verified ? 'Verified' : 'Not Verified',
          class_name: this.id_no_verified ? 'text-success' : 'text-danger',
        },
        {
          key_label: 'ID Match',
          value: this.identity_match || '—',
          class_name: this.identity_match === 'Matched' ? 'text-success' : 'text-danger',
        },
      ];
    },
  },




  mounted() {
    this.populateform_data();
    if (this.application_id) {
        this.get_user_verified_data();
    }
  },

  methods: {

    normalize_text(s) {
      return String(s).toLowerCase().replace(/\s+/g, ' ').trim();
    },
    normalize_id(s) {
      return String(s).toUpperCase().replace(/[^A-Z0-9]/g, '');
    },

    populateform_data() {
      if (!this.raw_data) return;

      try {
        const json_string = this.raw_data.replace(/'/g, '"');
        const parsed_data = JSON.parse(json_string);
        const result = parsed_data.result;

        this.formData = {
          full_name: result.full_names,
          surname: result.surname,
          identity_number: result.id_number,
        };

        this.verification = {
          full_name: `${result.full_names} ${result.surname}`,
          identity_number: result.id_number,
          date_of_birth: result.date_of_birth,
        };

        this.identity_match = result.id_match;
      } catch (err) {
        this.show_error("Invalid raw verification data format.");
      }
    },


    get_user_verified_data() {
      axios.get(USER_VERIFIED_DATA, {
        headers: this.headers,
        params: { application_id: this.application_id }
      })
      .then(response => {
        const parsed_response = response.data;

        if (parsed_response.status === 'success' && parsed_response.data.length > 0) {
          const result = parsed_response.data[0];
          const raw = result.raw_response;

          this.formData = {
            full_name: raw.full_names || '',
            surname: raw.surname || '',
            identity_number: raw.id_number || ''
          };

          this.verification = {
            full_name: `${raw.full_names || ''} ${raw.surname || ''}`.trim(),
            identity_number: raw.id_number || '',
            date_of_birth: raw.date_of_birth || ''
          };

          this.identity_match = raw.id_match || '';
          this.id_no_verified = result.id_no_verified || false;
        }

      })
      .catch((error) => {
        this.show_error('Error fetching user verification data: ' + error.message);
      });
    }


  }
}